import * as yup from "yup";
import {IContractorSearchForm, IRFMContractorDataForm, IRoyaltiesSearchFilters } from "../model/model";

export const CONTRACTOR_DATA_FORM_CUSTOM_VALUES: IRFMContractorDataForm = {
    contractorData: {
        naming: '',
        acgIdentificationCode: '',
        bpCode: '',
        serviceType: [],
        bpCodeOfTheRepresentative: '',
        taxCode: '',
        representativeIdentificationCode: '',
        commercialExecutiveMail: '',
        prefixCommercialExecutiveDeskPhone: {
            code: '',
            description: '',
            label: ''
        },
        commercialExecutiveDeskPhone: '',
        prefixCommercialExecutiveCellPhone: {
            code: '',
            description: '',
            label: ''
        },
        commercialExecutiveCellPhone: '',
        nameOfTheContactPerson: '',
        emailOfTheContactPerson: '',
        cellPhoneNumberOfTheContactPerson: '',
        prefixCellPhoneNumberOfTheContactPerson: {
            code: '',
            description: '',
            label: ''
        },
        iban: '',
        icaoCode: '',
        iataCode: '',
        companyName: '',
        type: '',
        notes: '',
        currentStatus: '',
        royaltiesDued: 'NO',
        vatNumber: '',
        siren:'',
        siret:'',
        fiscalCode: '',
        legalAddress: '',
        legalStreetNumber: '',
        postalCode: '',
        area: '',
        areaManager: '',
        region: '',
        country: '',
        province: '',
        city: '',
        fax: '',
        pec: '',
        commercialExecutiveName: '',
        RFMFilterParams: {}
    }
}

// Form's initial values
export const CONTRACTOR_DATA_FORM_INITIAL_VALUE: IRFMContractorDataForm = {
    contractorData: {
        naming: '',
        acgIdentificationCode: '',
        bpCode: '',
        serviceType: [],
        bpCodeOfTheRepresentative: '',
        taxCode: '',
        representativeIdentificationCode: '',
        commercialExecutiveMail: '',
        prefixCommercialExecutiveDeskPhone: {
            code: '',
            description: '',
            label: ''
        },
        commercialExecutiveDeskPhone: '',
        prefixCommercialExecutiveCellPhone: {
            code: '',
            description: '',
            label: ''
        },
        commercialExecutiveCellPhone: '',
        nameOfTheContactPerson: '',
        emailOfTheContactPerson: '',
        cellPhoneNumberOfTheContactPerson: '',
        prefixCellPhoneNumberOfTheContactPerson: {
            code: '',
            description: '',
            label: ''
        },
        iban: '',
        icaoCode: '',
        iataCode: '',
        companyName: '',
        type: '',
        notes: '',
        currentStatus: '',
        royaltiesDued: 'NO',
        vatNumber: '',
        siren:'',
        siret:'',
        fiscalCode: '',
        legalAddress: '',
        legalStreetNumber: '',
        postalCode: '',
        area: '',
        areaManager: '',
        country:'',
        region: '',
        province: '',
        city: '',
        fax: '',
        pec: '',
        commercialExecutiveName: '',
        RFMFilterParams: {}
    }
}


// Form's initial values
export const CONTRACTOR_SEARCH_INITIAL_VALUE: IContractorSearchForm = {
    icaoCode: '',
    iataCode: '',
    companyName: '',
    type: '',
    currentStatus: '',
    vatNumber: '',
    siren:'',
    fiscalCode: '',
    city: '',
    region: '',
    province: '',
    bpCode:'',
    country: '',
    tenants: null,
    dealers: null
}

// Validation Schema
export const CONTRACTOR_DATA_FORM_VALIDATION_SCHEMA = yup.object().shape({
    contractorData: yup.object({
        icaoCode: yup.string()
            .nullable(),
        iataCode: yup.string()
            .nullable(),
        companyName: yup.string()
            .required("common.error.required"),
        type: yup.string()
            .nullable()
            .required("common.error.required"),
        notes: yup.string()
            .nullable(),
        currentStatus: yup.string()
            .required('common.error.required'),
        royaltiesDued: yup.string()
            .nullable()
            .required("common.error.required"),
        vatNumber: yup.string()
            .required("common.error.required"),
        siren: yup.string()
            .nullable(),
        siret: yup.string()
            .nullable(),
        legalAddress: yup.string()
            .required("common.error.required"),
        legalStreetNumber: yup.string()
            .required("common.error.required"),
        cap: yup.string()
            .nullable(),
        area: yup.string()
            .nullable(),
        areaManager: yup.string()
            .nullable(),
        region: yup.string()
            .nullable(),
        province: yup.string()
            .nullable(),
        city: yup.string()
            .nullable(),
        fax: yup.string()
            .nullable(),
        pec: yup.string()
            .nullable()
            .email('common.error.email.isNotValid'),
        commercialExecutiveName: yup.string()
            .required("common.error.required")
    })
});


export const CONTRACTOR_DOCUMENTS_FORM_VALIDATION_SCHEMA = yup.object().shape({
    documents: yup.array().of(yup.object().shape({
        file: yup.string().required("common.error.required"),
        title: yup.string().nullable().required("common.error.required"),
        note: yup.string().ensure().when('title', {
            is: 'Other',
            then: yup.string().required("common.error.required")
          }),
        validityStartDate: yup.date().required("common.error.required"),
        validityEndDate: yup.date().min(
            yup.ref("validityStartDate"),
            "common.error.greaterEqualThanStartDate"
         ).required("common.error.required"),
    }))

});

export const ROYALTIES_SEARCH_FILTERS_FORM_INITIAL_VALUES : IRoyaltiesSearchFilters = {
    tenants: null,
    dealers: null,
};
